export default __webpack_public_path__ + "static/alio-logo-155fa4aa38283d85f02ae643fb4e44bf.svg";